export default {
    hasUrlParameter: (paramName) => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.has(paramName);
    },
    removeUrlParameter: (paramName) => {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.delete(paramName);
        const newUrl = window.location.origin + window.location.pathname + `${urlParams.size > 0 ? '?' + urlParams.toString() : ''}`;
        window.history.replaceState({}, document.title, newUrl);
    }
}
